<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <router-view name="header"></router-view>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
// Loading some plugin css asynchronously
import 'sweetalert2/dist/sweetalert2.css'
import 'vue-notifyjs/themes/default.css'
import 'vue-toast-notification/dist/theme-sugar.css';

export default {
  updated() {
  },
  methods: {
  }
}
</script>
<style lang="stylus">
nav[aria-label="breadcrumb"]{
  ol{
    background-color: #ffffff;
    li{
      a{
        color: #3F51B5;
        text-decoration: none;
        font-weight: 600;
        &:hover{
          text-decoration underline;
        }
      }
    }
  }
}

.v--modal-overlay {
		.container{
				height 100%;
			.row{
				height 100%;
			}
		}
		.content{
			height: calc(100% - 60px);
			position: relative;
			display: block;
		}
		.loader_holder {
			display: none;
		}
		&.loading {
			.loader_holder {
				display: block;
			}
			.content {
				display: none;
			}
		}
    .buttons{
      text-align right;
      button.styled{
        margin: 20px 5px !important;
      }
    }
    
		h2 {
			margin-top: 10px;
			color: #484848;
			margin-bottom: 10px;
		}
		.label {
			color: #a7a7a7;
		}
		.value {
			margin-left: 5px;
		}
		.loader_holder {
			text-align: center;
		}
		.close{
			position: absolute;
			top: 4px;
			right: 8px;
			z-index 1;
		}

    .alert{
      background: #FF5722;
      margin-top: 10px;
      border: 2px solid #D84315;
    }
}
</style>